<template>
  <div class="info-box">
    <div class="flex-1 flex flex-col gap-y-3 overflow-y-auto pr-2">
      <ul class="flex gap-x-3 items-center">
        <strong>{{ state.model?.name }}</strong>
        <text class="text-gray-400 text-xs">{{ state.model?.number }}</text>
      </ul>
      <ul class="flex gap-x-5">
        <c_cell
          title="类型"
          :value="
            state.model?.d_office_expense_type_pname +
            ' - ' +
            state.model?.d_office_expense_type_name
          "
        />
        <c_cell title="支付渠道">
          <c_status
            arrName="Office_Expense_Apply_Payment_Method"
            :value="state.model?.payment_method"
            :key="state.model?.payment_method"
          />
        </c_cell>
        <c_cell title="乙方" v-if="state.model?.payment_method == 1">
          <template #default>
            <text>{{ state.model?.billUnit?.name }}</text>
            <text class="ml-1 text-xs text-gray-400">{{
              state.model?.billUnit?.number
            }}</text>
          </template>
        </c_cell>
      </ul>
      <c_cell title="申请说明" :value="state.model?.intro" />
      <div class="flex items-center text-gray-400 text-xs gap-x-2">
        <text class="text-sm text-gray-600">
          {{ state.model?.add_admin_name }}
        </text>
        <text>{{ state.model?.add_department_name }}</text>
        <text class="ml-1">{{ state.model?.create_time }} 付款</text>
      </div>
      <ul class="grid" style="grid-template-columns: 1fr auto auto">
        <strong>采购明细</strong>
        <strong>合计金额：</strong>
        <c_money
          :value="state.model?.amount"
          :key="state.model?.amount"
          :size="18"
          bold
        />
      </ul>
      <div>
        <el-table
          :data="state.list_data"
          v-loading="!Array.isArray(state.list_data)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          height="auto"
        >
          <el-table-column
            prop="date"
            label="发生日期"
            align="center"
            :width="120"
          />
          <el-table-column
            prop="money"
            label="费用金额"
            align="right"
            :width="120"
            :formatter="$tab_MoneyFormat"
          />
          <el-table-column
            prop="intro"
            label="费用说明"
            :formatter="$tab_TextFormat"
          />
          <el-table-column label="附件">
            <template #default="{ row }">
              <c_UploadFile
                v-if="row.attachment?.length > 0"
                :key="row.attachment"
                :value="row.attachment"
                :showAdd="false"
                :showText="true"
              />
              <text v-else>-</text>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template v-if="state.model?.status == 0 && !props.search">
        <div
          class="border-t border-green-800 border-dashed mt-2 text-center flex justify-center"
        >
          <li
            class="text-green-800 font-bold bg-white px-5"
            style="margin-top: -10px; width: fit-content"
          >
            审批
          </li>
        </div>
        <el-input
          v-model="state.remark"
          type="textarea"
          :autosize="{ minRows: 3 }"
          placeholder="说明"
          class="round"
        />
        <div class="flex items-center justify-center">
          <el-button type="danger" @click="onSubmit(2)" size="large"
            >不通过</el-button
          >
          <el-button
            type="primary"
            @click="onSubmit(1)"
            size="large"
            class="!w-32"
            >通过</el-button
          >
        </div>
      </template>
      <strong>审核进度</strong>
      <el-steps :active="state.model.step" align-center>
        <el-step
          v-for="item in state.flowApproveStepList"
          :key="item"
          :title="item.step_name"
          :description="state.model.create_time"
        >
          <template #title>
            <div class="flex items-center gap-x-1 justify-center">
              <strong>{{ item.step_name }}</strong>
              <c_status arrName="Common_Check_Status" :value="item.status" />
            </div>
          </template>
          <template #description>
            <div class="flex flex-col items-center">
              <ul class="flex gap-x-1">
                <text>{{ item?.approve_admin_name }}</text>
                <text class="text-gray-400">{{
                  item?.approve_department_name
                }}</text>
                <text>{{ item.approve_time }}</text>
              </ul>
              <ul v-if="item?.log?.msg" class="text-xs">
                <text class="text-gray-400">备注：</text>
                <text class="text-gray-500">{{ item?.log?.msg }}</text>
              </ul>
            </div>
          </template>
        </el-step>
      </el-steps>
    </div>
    <div class="submit-box px-2.5">
      <el-button plain size="large" @click="state.showPrint = true">
        打印
      </el-button>
    </div>
  </div>
  <el-dialog
    v-model="state.showPrint"
    title="费用单据打印"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showPrint = false;
      }
    "
    style="width: 70%"
    append-to="#home_box"
    modal
  >
    <c_print :id="props.id" @close="state.showPrint = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  officeExpenseApprove_search,
  officeExpenseApprove_approve,
} from "@/http/bangongfeiyong";
import { ElMessageBox, ElMessage } from "element-plus";
import { post_response } from "@/utils/funcs";

import c_print from "./Print.vue";

export default {
  props: {
    id: Number,
    search: Boolean,
  },
  components: {
    c_print,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        id: props.id,
      },
      check: {},
      meeting: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.id) {
        officeExpenseApprove_search(props.id).then((res) => {
          if (res.status == 200) {
            const {
              info,
              flowApproveStepList,
              officeExpenseApplyRelationList,
            } = res.data?.data || {};
            state.model = info;
            state.list_data = officeExpenseApplyRelationList;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    };

    const onSubmit = (pass) => {
      if (pass == 2 && !state.remark) {
        ElMessage.warning("请输入审批说明！");
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style="color: ${pass == 1 ? "#080" : "#f00"};">${
          pass == 1 ? "同意" : "拒绝"
        }</strong>该费用申请吗？`,
        "费用审批",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        officeExpenseApprove_approve({
          id: [props.id],
          status: pass,
          msg: state.remark,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };
    return { state, props, formDom, onSubmit };
  },
};
</script>

<style lang="less" scoped></style>
